import React from 'react';
import { CLIENT_ENDPOINT } from '../constants/client-endpoint';
import { useAutoEnrollmentFeatureVisibility } from '../hooks/use-auto-enrollment-feature-visibility';

export const AutoEnrollmentButton = ({
    navLinkComponent
}) => {
    const isVisible = useAutoEnrollmentFeatureVisibility();
    if (!isVisible) {
        return null;
    }
    const Component = navLinkComponent;
    return (
        <Component
            to={CLIENT_ENDPOINT}
        >
            AUTO ENROLLMENT
        </Component>
    );
};
